module.exports = __webpack_public_path__ + "assets/img/logo.85afa95d.png";